<script setup>
import { VDialog } from 'vuetify/lib/components/index.mjs'

const props = defineProps({
  modelValue: { 
    type: Boolean,
     default: false 
    },
  targetId: { 
    type: [Number, String], 
    default: null 
  },
  type: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue', 'edit', 'delete', 'cancel'])

const open = computed({
  get: () => props.modelValue,
  set: v  => emit('update:modelValue', v),
})

function choose(type) {
  open.value = false
  if (type === 'edit')   emit('edit',   props.targetId)
  if (type === 'delete') emit('delete', props.targetId)
  if (type === 'report') emit('report', props.targetId)
  if (type === 'cancel') emit('cancel')
}
</script>

<template>
  <Teleport to="body">
    <VDialog
      v-model="open"
      width="300"
      persistent
      :scrim="true"
      :scroll-strategy="'block'"
      transition="scale-transition"
    >
      <VCard
        v-if="type === 'action'"
        class="sheet-card" 
        elevation="8">
        <button class="action" @click="choose('edit')">수정하기</button>
        <div class="divider"/>
        <button class="action" @click="choose('delete')">삭제하기</button>
        <div class="divider"/>
        <button class="action danger" @click="choose('cancel')">취소하기</button>
      </VCard>

      <VCard
        v-if="type === 'report'"
        class="sheet-card" 
        elevation="8">
        <button class="action" @click="choose('report')">신고하기</button>
        <div class="divider"/>
        <button class="action danger" @click="choose('cancel')">취소하기</button>
      </VCard>
    </VDialog>
  </Teleport>
</template>



<style scoped lang="scss">
.sheet-card { 
  overflow: hidden;
  border-radius: 16px !important;
}
.divider {
  width: 100%;
  height: 1px;
  background-color: var(--Gray-300, #EBEBEB);
}
.action { 
  width:100%; 
  padding:14px 12px; 
  background:transparent;
  border:0; 
  font-size:16px;
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.action.danger {
  color: var(--Orange-500-Error, #FF453A); 
}
.action.cancel {
  color:#8E8E93; 
}
</style>
